/**
 * Minimal local `window.shave` — truncates an element's text to fit a max pixel
 * height, appending an ellipsis at a word boundary.
 *
 * Replaces the external shave.js jsdelivr/cdnjs script the card truncation used to
 * lazy-load (see components/card.js `loadShaveLib`, which checks `window.shave`
 * first — so defining it here means no CDN fetch). A per-page external CDN script
 * is a privacy concern on this privacy-first site and breaks offline; bundling the
 * few lines we actually use fixes both. Signature matches how card.js calls it:
 * `shave(node, maxHeightPx)`.
 *
 * @param {Element|string} target  Element (or selector) to truncate.
 * @param {number} maxHeight       Max height in px the text must fit within.
 */
window.shave = function ( target, maxHeight ) {
	const el =
		typeof target === 'string'
			? document.querySelector( target )
			: target && target.nodeType
				? target
				: target && target.el
					? target.el[ 0 ]
					: null;

	if ( ! el || ! maxHeight ) {
		return;
	}

	// Keep the full text so re-runs (e.g. on resize) start from the original.
	const full = el.getAttribute( 'data-shave-full' ) || el.textContent;
	el.setAttribute( 'data-shave-full', full );
	el.textContent = full;

	if ( el.scrollHeight <= maxHeight ) {
		return; // already fits — no ellipsis
	}

	const words = full.trim().split( /\s+/ );
	let lo = 1;
	let hi = words.length;
	let best = 1;

	while ( lo <= hi ) {
		const mid = ( lo + hi ) >> 1;
		el.textContent = words.slice( 0, mid ).join( ' ' ) + '…';
		if ( el.scrollHeight <= maxHeight ) {
			best = mid;
			lo = mid + 1;
		} else {
			hi = mid - 1;
		}
	}

	el.textContent = words.slice( 0, best ).join( ' ' ) + '…';
};
